import { render, staticRenderFns } from "./InsuredPolicyDetail.vue?vue&type=template&id=9b8b735e&scoped=true&"
import script from "./InsuredPolicyDetail.vue?vue&type=script&lang=js&"
export * from "./InsuredPolicyDetail.vue?vue&type=script&lang=js&"
import style0 from "./InsuredPolicyDetail.vue?vue&type=style&index=0&id=9b8b735e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8b735e",
  null
  
)

export default component.exports